<script>
import columns from '@/pages/promotions/promoTemplates/columns';
import { mapActions, mapState } from 'vuex';
import CreateOrEditPromoTemplate
  from '@/pages/promotions/promoTemplates/createOrEditPromoTemplate/Create-or-edit-promo-template.vue';
import EditDesktopOrMobileCssStyle
  from '@/pages/promotions/promoTemplates/editDesktopOrMobileCssStyle/Edit-desktop-or-mobile-css-style.vue';
import { SearchOutlined } from '@ant-design/icons-vue';

export default {
  components: { SearchOutlined, EditDesktopOrMobileCssStyle, CreateOrEditPromoTemplate },
  data() {
    return {
      columns: columns(),
      showCreate: false,
      showEdit: false,
      showCss: false,
      showPreview: false,
      isMobilePreview: false,
      selectedId: null,
      promoTemplateChecked: undefined,
      searchText: '',
      templateList: [],
    };
  },
  mounted() {
    this.getPromoTemplatesAction();
  },
  methods: {
    ...mapActions({
      getPromoTemplatesAction: 'promotions/getPromoTemplates',
      deleteTemplateAction: 'promotions/deleteTemplate',
      changeActiveTemplateAction: 'promotions/changeActiveTemplate',
      copyBannerTemplateAction: 'promotions/copyBannerTemplate',
    }),
    openNewModal() {
      this.showCreate = true;
    },
    copyTemplate(value) {
      const {
        name,
        steps,
        banner,
        css,
      } = value;
      const {
        text,
        countDown,
        countDownText,
        dropDownText,
        mobileDropDownText,
      } = banner;
      const sortedSteps = steps.sort((a, b) => a.name.slice(-1) - b.name.slice(-1));
      const bannerSteps = sortedSteps.map((step) => {
        const {
          title,
          subtitle,
          buttonText,
          disclaimerText,
          body,
          desktopImage,
          mobileImage,
          name: stepName,
          textBox1,
          textMob2,
        } = step;
        const newStep = {
          name: stepName,
          title,
          subtitle,
          buttonText,
          disclaimerText,
          body,
          desktopImage,
          mobileImage,
          textBox1,
          textMob2,
        };
        return newStep;
      });
      const bannerTemplate = {
        name,
        css,
        banner: {
          text,
          countDown,
          countDownText,
          dropDownText,
          mobileDropDownText,
        },
        steps: bannerSteps,
      };
      this.copyBannerTemplateAction(bannerTemplate);
    },
    deleteTemplate(id) {
      this.deleteTemplateAction(id);
    },
    changeActive(id, value) {
      const payload = {
        id,
        params: {
          isActive: value,
        },
      };
      this.changeActiveTemplateAction(payload);
    },
    editCss(id) {
      this.selectedId = id;
      this.showCss = true;
    },
    checkTemplate(id) {
      this.selectedId = id;
      this.promoTemplateChecked = this.templates.filter((item) => item.id === id);
    },
    editContent(id) {
      this.showEdit = true;
      this.checkTemplate(id);
    },
    previewDesktop(id) {
      this.isMobilePreview = false;
      this.showPreview = true;
      this.checkTemplate(id);
    },
    previewMobile(id) {
      this.isMobilePreview = true;
      this.showPreview = true;
      this.checkTemplate(id);
    },
    hideModal() {
      this.showEdit = false;
    },
    hideModalCreate() {
      this.showCreate = false;
    },
  },
  computed: {
    ...mapState({
      templates: (state) => state.promotions.templates,
    }),
  },
  watch: {
    current(newValue) {
      this.offset = (newValue - 1) * this.pageSize;
    },
    pageSize() {
      if (this.current === 1) {
        this.offset = 0;
      }
      this.current = 1;
    },
    templates(value) {
      this.templateList = value;
    },
    searchText(value) {
      if (value) {
        this.templateList = this.templates.filter(
          (item) => item.name.toLowerCase().includes(value.toLowerCase()),
        );
      } else {
        this.templateList = this.templates;
      }
    },
  },
};
</script>

<template>
  <div class="top-buttons">
    <div class="search-field">
      <a-input
          placeholder="Search by name..."
          style="width: 350px"
          v-model:value="searchText"
      >
        <template #suffix>
          <search-outlined />
        </template>
      </a-input>
    </div>
    <div class="create-button">
      <a-button
          type="primary"
          html-type="button"
          @click="openNewModal()"
      >
        Create new template
      </a-button>
      <div v-if="showCreate">
        <a-modal
            :open="showCreate"
            :footer="null"
            @cancel="hideModalCreate"
            width="800px"
        >
          <create-or-edit-promo-template :hide-modal="hideModalCreate" />
        </a-modal>
      </div>
    </div>
  </div>
  <a-table
    :columns="columns"
    :dataSource="templateList"
  >
    <template #bodyCell="{ column, text, record }">
      <template v-if="column.dataIndex === 'content'">
        <a-button
          type="primary"
          html-type="button"
          @click="editContent(record.id)"
        >
          Edit content
        </a-button>
        <div v-if="showEdit && selectedId && selectedId === record.id">
          <a-modal
              :open="showEdit"
              :footer="null"
              @cancel="hideModal"
              width="800px"
          >
            <create-or-edit-promo-template
                :hide-modal="hideModal"
                :promo-template-checked="promoTemplateChecked"
            />
          </a-modal>
        </div>
      </template>
      <template v-if="column.dataIndex === 'desktop'">
        <a-button
          type="primary"
          html-type="button"
          @click="previewDesktop(record.id)"
        >
          Preview
        </a-button>
        <div v-if="showPreview && !isMobilePreview && selectedId && selectedId === record.id">
          <edit-desktop-or-mobile-css-style
            :type-preview="isMobilePreview"
            :promo-template-checked="promoTemplateChecked"
            v-model:show="showPreview"
          />
        </div>
      </template>
      <template v-if="column.dataIndex === 'mobile'">
        <a-button
          type="primary"
          html-type="button"
          @click="previewMobile(record.id)"
        >
          Preview
        </a-button>
        <div v-if="showPreview && isMobilePreview && selectedId && selectedId === record.id">
          <edit-desktop-or-mobile-css-style
            :type-preview="isMobilePreview"
            :promo-template-checked="promoTemplateChecked"
            v-model:show="showPreview"
          />
        </div>
      </template>
      <template v-if="column.dataIndex === 'isActive'">
        <div >
          <a-switch
            :checked="text"
            checked-children="Yes"
            un-checked-children="No"
            @change="changeActive(record.id, !text)"
          ></a-switch>
        </div>
      </template>
      <template v-if="column.dataIndex === 'delete'">
        <div>
          <a-button
            type="primary"
            class="button"
            html-type="button"
            @click="copyTemplate(record)"
          >
            Copy template
          </a-button>
          <a-popconfirm
            title="Sure to delete?"
            @confirm="deleteTemplate(record.id)"
          >
            <a-button type="primary" html-type="button" danger>
              Delete
            </a-button>
          </a-popconfirm>
        </div>
      </template>
    </template>
  </a-table>
</template>

<style scoped lang="scss">
.top-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.create-button {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}
.button {
  margin-right: 20px;
}
</style>
